// extracted by mini-css-extract-plugin
module.exports = {"title":"About_title__2iv-y","nav":"About_nav__1dwnz","btn":"About_btn__3JunX","active":"About_active__2IxzF","dropdown":"About_dropdown__2omWO","list":"About_list__1Y1-w"};